import { ProjectRole } from "@/enums/ProjectRole";
import { UserPermissionsSchema, type UserPermissions } from "@/types/User";

export class Permissions {
  canSubmit: boolean = false;
  canEnterDrawAmountManually: boolean = false;
  canEnterInspectionPercentagesManually: boolean = false;
  canDownloadSpreadsheetForProject: boolean = false;
  canDownloadAllWorksheets: boolean = false;
  canUploadFinishedWorksheets: boolean = false;
}

export const getPermissions = (role: ProjectRole): Permissions => {
  const permissions = new Permissions();
  switch (role) {
    case ProjectRole.LENDER:
    case ProjectRole.PRIMARY_LENDER:
    case ProjectRole.PROCESSOR:
    case ProjectRole.BORROWER:
    case ProjectRole.PRIMARY_BORROWER:
    case ProjectRole.BUILDER:
    case ProjectRole.PRIMARY_BUILDER:
    case ProjectRole.CONTACT:
    case ProjectRole.LOAN_OFFICER:
    case ProjectRole.TITLE_COMPANY:
      permissions.canSubmit = true;
      permissions.canEnterDrawAmountManually = true;
      permissions.canDownloadSpreadsheetForProject = true;
      permissions.canDownloadAllWorksheets = true;
      permissions.canUploadFinishedWorksheets = true;
      break;
    case ProjectRole.INSPECTOR:
    case ProjectRole.PRIMARY_INSPECTOR:
      permissions.canSubmit = true;
      permissions.canEnterInspectionPercentagesManually = true;
      permissions.canDownloadSpreadsheetForProject = true;
      permissions.canDownloadAllWorksheets = true;
      permissions.canUploadFinishedWorksheets = true;
      break;
    default:
      break;
  }

  return permissions;
};

export const getUserPermissions = async (userId: string): Promise<UserPermissions> => {
  let permissions: UserPermissions = UserPermissionsSchema.parse({});

  await axios
    .get("/users/permissions?id=" + userId)
    .then((response) => {
      return (permissions = UserPermissionsSchema.parse(response.data.result));
    })
    .catch((e) => errorApi(e));

  return permissions;
};

export const permissionError = () => {
  error(
    "Action Restricted",
    "You do not have permission to do this action. To gain access to this feature, please contact your system administrator"
  );
};
